angular.module('app.pages.reports').component('achievementsCell', {
  bindings: {
    enabled: '<',
    name: '@',
    description: '@',
  },
  template: `
      <div ng-class="$ctrl.enabled ? 'unlocked' : 'locked'">
        <i ng-if="!$ctrl.enabled" class="fa fa-4x fa-trophy"></i>
        <i ng-if="$ctrl.enabled" class="fa fa-4x fa-trophy" uib-tooltip="{{$ctrl.description}}" tooltip-append-to-body="true"></i>
        <label ng-if="$ctrl.enabled" uib-tooltip="{{$ctrl.description}}" tooltip-append-to-body="true">{{$ctrl.name}}</label>
        <label ng-if="!$ctrl.enabled">&nbsp;</label>
      </div>
    `,
});



// WEBPACK FOOTER //
// ./app/pages/reports/components.js